/**
 * Global protection for number inputs to prevent scroll-induced value changes
 * This provides a fallback for any number inputs that aren't using our protected components
 */

let isInitialized = false;

/**
 * Handles wheel events on number inputs by blurring them
 */
const handleNumberInputWheel = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target && target.type === 'number') {
    target.blur();
  }
};

/**
 * Initializes global protection for all number inputs on the page
 * This should be called once when the app starts
 */
export const initializeGlobalNumberInputProtection = () => {
  if (isInitialized) {
    return;
  }

  // Add event listener to the document to catch all wheel events
  document.addEventListener('wheel', handleNumberInputWheel, { passive: true });

  isInitialized = true;
};
